import React from 'react';
import './Footer.css';


function Footer() {
    return (
        <footer id="cs-footer-269">
            <div className="cs-container">
                <div className="cs-logo-group">
                    <a aria-label="go back to home" className="cs-logo" href="/">
                        <img className="cs-logo-img light" aria-hidden="true" loading="lazy" decoding="async" src="/images/logo.svg" alt="logo" width="240" height="32"></img>
                    </a>
                    <p className="cs-text">
                        2419, W RAMSAY AVE, MILWAUKEE, WI, USA 53221. <br />
                        <a className="cs-text-link" href="tel: 414-763-2785">414-763-2785</a> | <a className="cs-text-link" href="tel: 262-955-3216">262-955-3216</a>
                    </p>
                    <p className="cs-text">
                        Krishna Temple ( Radha Madhav ) fullfuling All your Spiritual Aspiration.
                    </p>
                </div>
                <ul className="cs-nav">
                    <li className="cs-nav-li">
                        <span className="cs-header">Sitemap</span>
                    </li>
                    <li className="cs-nav-li">
                        <a className="cs-nav-link" href="/">Home</a>
                    </li>
                    <li className="cs-nav-li">
                        <a className="cs-nav-link" href="/krishna-temple-events">Events</a>
                    </li>
                    <li className="cs-nav-li">
                        <a className="cs-nav-link" href="/krishna-temple-contact">Contact</a>
                    </li>
                    <li className="cs-nav-li">
                        <a className="cs-nav-link" href="/radha-madhav-kitchen">Radha Madhav Kitchen</a>
                    </li>
                    <li className="cs-nav-li">
                        <a className="cs-nav-link" href="/donate">Donate</a>
                    </li>
                </ul>
                <ul className="cs-contact">
                    <li className="cs-nav-li">
                        <span className="cs-header">Contact</span>
                    </li>
                    <li className="cs-contact-li">
                        <a className="cs-contact-link" href="https://goo.gl/maps/xyz123">2419, W RAMSAY AVE, MILWAUKEE, WI, USA 53221</a>
                    </li>
                    <li className="cs-contact-li">
                        <a className="cs-contact-link" href="tel: 414-763-2785">414-763-2785 | 262-955-3216</a>
                    </li>
                    <li className="cs-contact-li">
                        <a className="cs-contact-link" href="mailto:contact@krishnatemplemilwaukee.org">contact@krishnatemplemilwaukee.org</a>
                    </li>
                    <li className="cs-contact-li cs-social-group">
                        <div className="cs-social">
                            <a className="cs-social-link" aria-label="visit google profile" href="https://www.google.com/search?q=krishna+temple+milwaukee">
                                <img className="cs-social-img" aria-hidden="true" loading="lazy" decoding="async" src="/images/google.svg" alt="google" width="11" height="11"></img>
                            </a>
                            <a className="cs-social-link" aria-label="visit facebook profile" href="https://www.youtube.com/user/MilwaukeeKrishnaTemp/videos">
                                <img className="cs-social-img" aria-hidden="true" loading="lazy" decoding="async" src="/images/Facebook.svg" alt="facebook" width="6" height="11"></img>
                            </a>
                            <a className="cs-social-link" aria-label="visit instagram profile" href="https://www.youtube.com/user/MilwaukeeKrishnaTemp/videos">
                                <img className="cs-social-img" aria-hidden="true" loading="lazy" decoding="async" src="/images/instagram.svg" alt="instagram" width="11" height="11"></img>
                            </a>
                            <a className="cs-social-link" aria-label="visit youtube channel" href="https://www.youtube.com/user/MilwaukeeKrishnaTemp/videos">
                                <img className="cs-social-img" aria-hidden="true" loading="lazy" decoding="async" src="/images/youtube.svg" alt="youtube" width="11" height="11"></img>
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </footer>
    );
}
export default Footer;